import { useContext } from 'react'
import { BillingContext } from '../contexts/BillingContext'

export default function useBilling() {
  const { bills, subscriptions, refreshNow } = useContext(BillingContext)

  return {
    bills, subscriptions, refreshNow
  }
}
